import { ArrowLeft, X } from 'lucide-react';
import { stateAtom, districtAtom, blockAtom, dataJsonAtom } from '../store/locationStore.jsx';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import { trackEvent } from "../services/analytics.js";
import { CheckCircle2, Layers3,Table } from "lucide-react";

const KYLMWSProfilePanel = ({ mwsData, onBack, hideBackButton = false, onResetMWS,onOpenSelection,
  selectedMWS = [],  intersectingVillages = [],onRemoveMWS }) => {
  const state = useRecoilValue(stateAtom);
  const district = useRecoilValue(districtAtom);
  const block = useRecoilValue(blockAtom);
  const dataJson = useRecoilValue(dataJsonAtom)

  const [dataString, setDataString] = useState("")

  const transformName = (name) => {
    if (!name) return name;
    return name
          .replace(/[()]/g, "")
              // .replace(/-+/g, "_")
              .replace(/\s+/g, "_")
              .replace(/_+/g, "_")
              .replace(/^_|_$/g, "")
              .toLowerCase()
  };

  const handleReportDownload = (id) => {
    trackEvent("Generate MWS Report", "generate_report", JSON.stringify([state.label, district.label, block.label, id]));
    window.open(`${process.env.REACT_APP_API_URL}/generate_mws_report/?state=${transformName(state.label)}&district=${transformName(district.label)}&block=${transformName(block.label)}&uid=${id}`, '_blank');
  }

  const buildVillageReportUrl = (villageId) =>
  `${process.env.REACT_APP_API_URL}/generate_village_report/?state=${transformName(state?.label)}&district=${transformName(district?.label)}&block=${transformName(block?.label)}&villageId=${villageId}`;

  useEffect(() => {
    if (dataJson !== null) {
      const found = dataJson.find((item) => item.mws_id === mwsData?.uid)
      try {
        const terrainType = ["Broad Slopes and Hilly", "Mostly Plains", "Hills and Valleys", "Broad Slopes and Plains"]
        
        let dataStr = `The Selected MWS has a Terrain of type ${terrainType[found.terrainCluster_ID]}, intersecting with ${found.mws_intersect_villages.length} villages also having ${found.total_nrega_assets} NREGA assets which lies in the selected MWS. The average cropping intensity across the MWS's is ${found.cropping_intensity_avg.toFixed(2)} with an ${Math.round(found.avg_precipitation)} mm average precipitation.`

        setDataString(dataStr)
      } catch (err) {
        console.log(err)
        console.log(found)
      }
    }
  }, [dataJson, mwsData])

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-3">
        
      {!hideBackButton && (
        <div className="flex items-center gap-2 mb-4 mt-4">
          <button 
            onClick={onBack}
            className="hover:bg-gray-100 p-1 rounded-full"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600" />
          </button>
          <h2 className="text-lg font-medium">Micro watershed profile</h2>
        </div>
      )}
      
      
      {hideBackButton && (
        <h2 className="text-lg font-medium mb-4">Micro watershed profile</h2>
      )}   
                

{selectedMWS.length <= 1 ? (
  <>
    <div className="space-y-2 mb-4">
      <p className="text-sm text-gray-600">
        Micro watershed Id: {mwsData?.uid || "--"}
      </p>
    </div>

    <div className="mb-4">
      <h3 className="font-medium mb-2">Overview</h3>
      <p className="text-sm text-gray-600">
        {dataString}
      </p>
      <p className="text-sm text-gray-600 mt-2">
        Read report for more details.
      </p>
    </div>


    <button
      className="flex items-center gap-2 text-indigo-600 hover:text-indigo-700 mb-2"
      onClick={() => handleReportDownload(mwsData?.uid)}
    >
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
      <span className="text-sm">View Micro-Watershed Profile</span>
    </button>
  </>
) : (
<div className="space-y-5">

  {/* Overview */}
  <div>
    <h3 className="font-medium text-gray-900 mb-2">
      Overview
    </h3>

    <p className="text-sm text-gray-600 leading-6">
      The selected <strong>{selectedMWS.length}</strong>{" "}
      micro watersheds are available for review.
      Click on any micro watershed below to open its detailed report.
    </p>
  </div>

      {onOpenSelection && (
        <div className="flex justify-start mt-4">
          <button
            onClick={onOpenSelection}
            className="flex justify-center items-center gap-1 px-4 py-1.5 text-[11px] font-semibold text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors border border-indigo-100"
          >
            <Table className="w-3 h-3" />
            View Selection
          </button>
        </div>
      )}
  <hr />
  

<div className="flex items-center justify-between mb-2">
  <h3 className="font-medium text-gray-900">
    Selected MWS
  </h3>

  <div className="w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-semibold flex items-center justify-center">
    {selectedMWS.length}
  </div>
</div>


  {/* Selected MWS List */}
<div className="space-y-3 max-h-[320px] overflow-y-auto overflow-x-hidden pt-2">

  {selectedMWS.map((uid, index) => (

    <div
      key={uid}
      className="relative flex items-center justify-between rounded-lg border border-gray-200 px-2 py-2 hover:border-indigo-300 hover:bg-indigo-50 transition"
    >

      {/* Remove MWS button - top right corner */}
      <button
        type="button"
        title="Remove from selection"
        onClick={(e) => {
          e.stopPropagation();
          onRemoveMWS?.(
            typeof uid === 'object' ? (uid.id ?? uid.uid) : uid
          );
        }}
        className="
          absolute -top-2 right-0      
          w-4 h-4
          flex items-center justify-center
          rounded-full
          bg-white
          border border-gray-200
          shadow-sm
          text-gray-400
          hover:text-red-500
          hover:border-red-200
          hover:bg-red-50
          transition-all
          z-10
        "
      >
        <X className="w-2 h-2" />
      </button>

      {/* Left side - Number + UID */}
      <div className="flex items-center gap-3">

        <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-semibold">
          {index + 1}
        </div>

        <div>
          <p className="text-sm font-medium text-gray-800">
            {typeof uid === 'object'
              ? (uid.name ?? uid.id ?? 'Unknown')
              : uid}
          </p>
        </div>

      </div>

      {/* View Profile */}
      <button
        className="flex items-center gap-1 text-indigo-600 hover:text-indigo-700 mr-2"
        onClick={() =>
          handleReportDownload(
            typeof uid === 'object'
              ? (uid.id ?? uid.uid)
              : uid
          )
        }
      >
        <svg
          className="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          />
        </svg>

        <span className="text-sm">View Profile</span>
      </button>

    </div>

  ))}

</div>

</div>
)}


       {intersectingVillages.length > 0 && (
  <div className="mt-5">
    <div className="flex items-center justify-between mb-3">
      <h3 className="font-medium text-gray-900">
        Selected Villages
      </h3>

      <div className="w-6 h-6 rounded-full bg-green-100 text-green-700 text-xs font-semibold flex items-center justify-center">
        {intersectingVillages.length}
      </div>
    </div>

    <div className="flex flex-wrap gap-2">
  {intersectingVillages.map((village) => (
    <button
      key={village.villageId}
      type="button"
      title={`Open report for ${village.villageName}`}
      onClick={() =>
        window.open(
          buildVillageReportUrl(village.villageId),
          "_blank",
          "noopener,noreferrer"
        )
      }
      className="px-3 py-1 rounded-full border border-green-200 bg-green-50 text-green-700 text-xs hover:bg-green-100 hover:border-green-300 transition-colors"
    >
      {village.villageName}
    </button>
  ))}
</div>
  </div>
)}
    </div>
  );
};

export default KYLMWSProfilePanel;